// 用户中心页面
const authPages = [
    {
        path: '/userInfo',
        name: "User",
        component: () => import("@/views/auth/UserInfo"),
        meta: { menuName: '个人账号信息' }
    },
    {
        path: '/employeeAccount',
        name: "EmployeeAccount",
        component: () => import("@/views/auth/EmployeeAccount"),
        meta: { menuName: '员工账号信息' }
    },
    {
        path: '/subSystemManage',
        name: "SubSystemManage",
        component: () => import("@/views/auth/SubSystemManage"),
        meta: { menuName: '平台系统管理' }
    },
    {
        path: '/authMenuInfoManage',
        name: "AuthMenuInfoManage",
        component: () => import("@/views/auth/AuthMenuInfoManage"),
        meta: { menuName: '菜单配置' }
    },
    {
        path: '/authMenuRoleManage',
        name: "AuthMenuRoleManage",
        component: () => import("@/views/auth/AuthMenuRoleManage"),
        meta: { menuName: '菜单角色管理' }
    },
];

export default authPages;
